import React, { createContext, useContext, useState } from "react";
import { IShowMenuContext } from "../exports/interfaces";

const ShowMenuContext = createContext<IShowMenuContext>({
  showMenu: true,
  setShowMenu: () => null,
});
export const useShowMenu = () => useContext(ShowMenuContext);

export const ShowMenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [showMenu, setShowMenu] = useState<boolean>(false);

  return (
    <ShowMenuContext.Provider value={{ showMenu, setShowMenu }}>
      {children}
    </ShowMenuContext.Provider>
  );
};
